module.exports = __webpack_public_path__ + "static/media/scan_sound.94c37445.wav";